









import Vue, { VueConstructor } from "vue";
import ColorSpectrum, { Point } from "./ColorSpectrum.vue";
import { Manager, Pan, Press } from "hammerjs";

type InputEvent = MouseEvent | TouchEvent;

interface Data {
  selected: string;
  width: number;
  height: number;
  down: boolean;
}

interface Swatches {
  $el: HTMLElement;
  getColor(windowX: number, windowY: number): string;
  getColorLocal(x: number, y: number): string;
  clampLocalXY(x: number, y: number): Point;
  getLocal(viewportX: number, viewportY: number): Point;
}

interface Opts {
  $options: {
    swatches: Swatches;
    resizeHandler: () => void;
    hammer: HammerManager;
  };
  $children: Swatches[];
  $el: HTMLElement;
}
export default (Vue as VueConstructor<Vue & Opts>).extend({
  components: {
    ColorSpectrum
  },
  props: {
    value: {
      type: String
    }
  },
  data(): Data {
    return {
      selected: "#ffffff",
      width: 0,
      height: 0,
      down: false
    };
  },
  computed: {
    selectedColor(): string {
      return this.selected || "#ffffff";
    }
  },
  mounted() {
    this.selected = this.value || "#ffffff";
    this.resizeHandler();
    this.$options.resizeHandler = this.resizeHandler.bind(this);
    window.addEventListener("resize", this.$options.resizeHandler);
    const mc = new Manager(this.$el);
    mc.add(new Press({ threshold: 1, time: 0 }));
    mc.add(new Pan({ threshold: 0 }));
    mc.on("panstart", e => this.onDown(e));
    mc.on("pan", e => this.onMove(e));
    mc.on("panend", e => this.onUp(e));
    mc.on("press", e => this.onDown(e));
    mc.on("pressup", e => this.onUp(e));
    this.$options.hammer = mc;
    this.$options.swatches = this.$children[0];
    this.$emit("input", this.selectedColor);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$options.resizeHandler);
    if (this.$options.hammer) {
      this.$options.hammer.destroy();
    }
  },
  methods: {
    onDown(e: HammerInput) {
      this.down = true;
      this.selectColorAt(e.center.x, e.center.y, "active");
    },
    onMove(e: HammerInput) {
      if (this.down) {
        this.selectColorAt(e.center.x, e.center.y, "change");
      }
    },
    onUp(e: HammerInput) {
      this.selectColorAt(e.center.x, e.center.y, "inactive");
      this.down = false;
    },
    selectColorAt(x: number, y: number, phase?: string) {
      const s = this.$options.swatches;
      const localPos = s.getLocal(x, y);
      const clampedPos = s.clampLocalXY(localPos.x, localPos.y);
      const diffX = localPos.x - clampedPos.x;
      const diffY = localPos.y - clampedPos.y;
      this.selected = s.getColorLocal(clampedPos.x, clampedPos.y);
      this.$emit("input", this.selected);
      if (phase) {
        this.$emit(phase, { x: x - diffX, y: y - diffY });
      }
    },
    resizeHandler() {
      this.width = this.$el.offsetWidth;
      this.height = this.$el.offsetHeight;
    }
  }
});
